const linkReducer = (state = {
    status: 'LOADING',
    msg: '',
    data: []
}, action) => {
    let current_data = JSON.parse(JSON.stringify(state.data));
    const status = typeof action.status !== 'undefined' ? action.status.toUpperCase(): null;

    switch(action.type){
        case "LINKS_LOAD":
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: status === 'OK'?action.payload:current_data
            }
            break;
        default:
    }
    return state;
}

export default linkReducer;